import React from "react";

/* This script comes from https://static.alchemyapi.io/scripts/badge/alchemy-badge.js
 *  Adapted to compile in Typescript
 *  */

const BEBOP_BADGE_ID = "8dbaf06b6246a11f";

const ALCHEMY_URL = `https://alchemyapi.io/?r=badge:${BEBOP_BADGE_ID}`;
const ALCHEMY_ANALYTICS_URL = `https://analytics.alchemyapi.io/analytics`;

export async function logBadgeClick(): Promise<void> {
  await fetch(`${ALCHEMY_ANALYTICS_URL}/badge-click`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      badge_id: BEBOP_BADGE_ID,
    }),
  });
  window.open(ALCHEMY_URL, "_blank")?.focus();
}

export async function logBadgeView(): Promise<void> {
  await fetch(`${ALCHEMY_ANALYTICS_URL}/badge-view`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      badge_id: BEBOP_BADGE_ID,
    }),
  });
}

export function isBadgeInViewpoint(bounding: DOMRect): boolean {
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

async function checkBadgeView() {
  const badge = document.getElementById("badge-button");
  if (badge && isBadgeInViewpoint(badge.getBoundingClientRect())) {
    await logBadgeView();
    clearInterval(intervalId);
  }
}

const intervalId = setInterval(() => {
  void checkBadgeView();
}, 2000);

export default function AlchemyBadge() {
  return (
    <button className="bg-transparent border-0 mt-3 ">
      <img
        onClick={() => void logBadgeClick()}
        className="img-fluid"
        id="badge-button"
        style={{ width: "192px" }}
        src="https://static.alchemyapi.io/images/marketing/badge.png"
        alt="Alchemy Supercharged"
      />
    </button>
  );
}
